import PropTypes from 'prop-types';
import React, {useMemo, useState} from 'react';
import {useQuery} from '@apollo/client';
import {isEmpty as _isEmpty} from 'lodash';

import {FiltersWrapper} from '@appComponents/HOCFiltersWrapper';
import {showErrorNotificationMessage} from '@modules/client/utils/lcppClientNotificationLog';
import {GetContentNamesWithDistributionsForDropdownData} from '@graphql/eventContent/query';
import {GetEventLcppClientsDataByEventContent} from '@graphql/lcppClientNotificationLog/query';
import {EventContentsFilter} from '@utils/commonFilters/EventContentsFilter';
import {ClientsFilter} from '@utils/commonFilters/ClientsFilter';

import {
    getEventContentWithLcppProduct,
    prepareEventContentNamesForDropdown,
} from '../utils/eventsLcppClientNotificationLog';

export const EventsLcppClientNotificationLogFilters = ({
    data: {
        eventId,
    },
    restoreFilterValues,
    filters,
}) => {
    let eventContentsOnlyWithLcpp = [],
        eventContentIds = [];
    const clients = [],
        [eventContentsData, setEventContentsData] = useState([]);

    const {
        error: errorEventContentsDropdownData,
        loading: isDataForEventContentsLoading = true,
    } = useQuery(GetContentNamesWithDistributionsForDropdownData, {
        variables: {
            id: eventId,
        },
        skip: !_isEmpty(eventContentsData),
        onCompleted: ({eventContents}) => {
            setEventContentsData(eventContents);
        },
    });

    if (!isDataForEventContentsLoading && eventContentsData) {
        eventContentsOnlyWithLcpp = getEventContentWithLcppProduct(eventContentsData);

        eventContentIds = eventContentsOnlyWithLcpp.map((eventContent) => {
            return Number(eventContent.id);
        });
    }

    const {
        data: {
            lcppClientNotificationsLog,
        } = {},
        error: errorDataForClients,
        loading: isDataForClientsLoading = true,
    } = useQuery(GetEventLcppClientsDataByEventContent, {
        variables: {
            eventContent: eventContentIds,
        },
        skip: _isEmpty(eventContentIds),
    });

    if (lcppClientNotificationsLog) {
        lcppClientNotificationsLog.forEach((lcppClientNotification) => {
            if (!clients.includes(lcppClientNotification.client)) {
                clients.push(lcppClientNotification.client);
            }
        });
    }

    const errorOccurredWhileFetchingData = errorEventContentsDropdownData || errorDataForClients;

    useMemo(() => {
        errorOccurredWhileFetchingData && showErrorNotificationMessage();
    }, [errorOccurredWhileFetchingData]);

    return (
        <div className='content__filters'>
            <EventContentsFilter
                loading={isDataForEventContentsLoading}
                filters={filters.EventsLcppClientNotificationLog}
                restoreFilterValues={restoreFilterValues}
                options={prepareEventContentNamesForDropdown(eventContentsOnlyWithLcpp)}
            />
            <ClientsFilter
                loading={isDataForEventContentsLoading || isDataForClientsLoading}
                filters={filters.EventsLcppClientNotificationLog}
                restoreFilterValues={restoreFilterValues}
                options={clients}
            />
        </div>
    );
};

EventsLcppClientNotificationLogFilters.propTypes = {
    data: PropTypes.shape({
        eventId: PropTypes.number.isRequired,
    }),
    filters: PropTypes.shape({
        EventsLcppClientNotificationLog: PropTypes.object.isRequired,
    }),
    restoreFilterValues: PropTypes.func.isRequired,
};

export default FiltersWrapper(EventsLcppClientNotificationLogFilters, {name: 'EventsLcppClientNotificationLog'});
